import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import AppRoutes from './routes';
const App = () => {
  return  <>
      <AppRoutes />
  </>
}
export default App;
